import { createSlice } from "@reduxjs/toolkit";

// Helper function to load initial state from localStorage
const getInitialCompare = () => {
  const storedCompare = localStorage.getItem("compare");
  return storedCompare ? JSON.parse(storedCompare) : [];
};

const CompareSlice = createSlice({
  name: "compare",
  initialState: {
    compare: getInitialCompare(),
  },
  reducers: {
    // Add to compare
    addToComapre: (state, action) => {
      const exists = state.compare.find(item => item._id === action.payload._id);
      if (!exists) {
        state.compare.push({ ...action.payload });
        localStorage.setItem("compare", JSON.stringify(state.compare));
      }
    },

    // Remove from compare
    removeFromCompare: (state, action) => {
      state.compare = state.compare.filter(item => item._id !== action.payload._id);
      localStorage.setItem("compare", JSON.stringify(state.compare));
    },

    // Initialize compare list manually
    initializeCompare: (state, action) => {
      state.compare = action.payload;
      localStorage.setItem("compare", JSON.stringify(action.payload));
    },
  },
});

export const {
  addToComapre,
  removeFromCompare,
  initializeCompare
} = CompareSlice.actions;

export default CompareSlice.reducer;
